import { action, observable, set } from "mobx";
import moment from "moment";
import Model from "~/models/Model";

class CreditAccount extends Model {
  /**
   * @property {number|null}
   */
  @observable creditAccountId = null;

  /**
   * @property {number|null}
   */
  @observable providerId = null;

  /**
   * @property {number|null}
   */
  @observable creditUsageId = null;

  /**
   * @property {number|null}
   */
  @observable creditCardTransactionId = null;

  /**
   * @property {number|null}
   */
  @observable amount = null;

  /**
   * @property {string|null}
   */
  @observable description = null;

  /**
   * @property {string|null}
   */
  @observable creationDts = null;

  /**
   * @property {Object}
   */
  @observable creditUsage = null;

  /**
   * @property {Object}
   */
  @observable creditCardTransaction = null;

  /**
   * Set new data to our model
   * @override
   * @param {object} data
   */
  @action
  setData(data) {
    const { creationDts, ...rest } = data;
    set(this, rest);

    this.creationDts = creationDts ? moment.unix(creationDts) : null;
  }
}

export default CreditAccount;
